import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../hooks/useAuth";

export default function LoginPage() {
  const { login, user } = useAuth();
  const navigate = useNavigate();
  const [tab, setTab] = useState("teacher");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const [teacherForm, setTeacherForm] = useState({ login_id: "", password: "" });
  const [studentForm, setStudentForm] = useState({ school_code: "", grade: "", class_name: "", student_number: "", password: "", nickname: "" });
  const [adminForm, setAdminForm] = useState({ login_id: "", password: "" });

  // userが変わったら自動でリダイレクト
  useEffect(() => {
    if (!user) return;
    if (user.role === "admin") navigate("/admin", { replace: true });
    else if (user.role === "teacher") navigate("/teacher", { replace: true });
    else if (user.role === "student") navigate("/student", { replace: true });
  }, [user, navigate]);

  async function handleTeacherLogin(e) {
    e.preventDefault();
    setLoading(true); setError("");
    try {
      const r = await fetch("/api/auth/user", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(teacherForm)
      });
      const d = await r.json();
      if (!r.ok) throw new Error(d.error);
      login(d.token);
    } catch(e) { setError(e.message); }
    setLoading(false);
  }

  async function handleStudentLogin(e) {
    e.preventDefault();
    setLoading(true); setError("");
    try {
      const r = await fetch("/api/auth/student", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ ...studentForm, grade: Number(studentForm.grade), student_number: Number(studentForm.student_number), class_name: studentForm.class_name.includes("組") ? studentForm.class_name : studentForm.class_name + "組" })
      });
      const d = await r.json();
      if (!r.ok) throw new Error(d.error);
      login(d.token);
    } catch(e) { setError(e.message); }
    setLoading(false);
  }

  async function handleAdminLogin(e) {
    e.preventDefault();
    setLoading(true); setError("");
    try {
      const r = await fetch("/api/auth/admin", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(adminForm)
      });
      const d = await r.json();
      if (!r.ok) throw new Error(d.error);
      login(d.token);
    } catch(e) { setError(e.message); }
    setLoading(false);
  }

  return (
    <div style={styles.wrap}>
      <div style={styles.card}>
        <div style={styles.logo}>💬</div>
        <h1 style={styles.title}>SNSまなびチャット</h1>
        <p style={styles.sub}>SNSの使い方を体験的に学ぼう</p>

        <div style={styles.tabs}>
          {["teacher","student","admin"].map(t => (
            <button key={t} style={{...styles.tab, ...(tab===t ? styles.tabActive : {})}} onClick={() => { setTab(t); setError(""); }}>
              {t === "teacher" ? "👩‍🏫 先生" : t === "student" ? "🎒 生徒" : "⚙️ 管理者"}
            </button>
          ))}
        </div>

        {error && <div style={styles.error}>{error}</div>}

        {tab === "teacher" && (
          <form onSubmit={handleTeacherLogin} style={styles.form}>
            <input style={styles.input} placeholder="ログインID" value={teacherForm.login_id}
              onChange={e => setTeacherForm({...teacherForm, login_id: e.target.value})} required />
            <input style={styles.input} type="password" placeholder="パスワード" value={teacherForm.password}
              onChange={e => setTeacherForm({...teacherForm, password: e.target.value})} required />
            <button style={styles.btn} disabled={loading}>{loading ? "ログイン中..." : "ログイン"}</button>
          </form>
        )}

        {tab === "student" && (
          <form onSubmit={handleStudentLogin} style={styles.form}>
            <input style={styles.input} placeholder="学校コード" value={studentForm.school_code}
              onChange={e => setStudentForm({...studentForm, school_code: e.target.value})} required />
            <div style={styles.row}>
              <input style={{...styles.input, flex:1}} placeholder="学年" type="number" min="1" max="6" value={studentForm.grade}
                onChange={e => setStudentForm({...studentForm, grade: e.target.value})} required />
              <input style={{...styles.input, flex:2}} placeholder="組" type="number" min="1" max="9" value={studentForm.class_name}
                onChange={e => setStudentForm({...studentForm, class_name: e.target.value})} required />
              <input style={{...styles.input, flex:1}} placeholder="番号" type="number" value={studentForm.student_number}
                onChange={e => setStudentForm({...studentForm, student_number: e.target.value})} required />
            </div>
            <input style={styles.input} placeholder="ニックネーム（チャットで表示される名前）" value={studentForm.nickname}
              onChange={e => setStudentForm({...studentForm, nickname: e.target.value})} required />
            <input style={styles.input} type="text" placeholder="パスワード" value={studentForm.password}
              onChange={e => setStudentForm({...studentForm, password: e.target.value})} required />
            <button style={styles.btn} disabled={loading}>{loading ? "ログイン中..." : "ログイン"}</button>
          </form>
        )}

        {tab === "admin" && (
          <form onSubmit={handleAdminLogin} style={styles.form}>
            <input style={styles.input} placeholder="管理者ID" value={adminForm.login_id}
              onChange={e => setAdminForm({...adminForm, login_id: e.target.value})} required />
            <input style={styles.input} type="password" placeholder="パスワード" value={adminForm.password}
              onChange={e => setAdminForm({...adminForm, password: e.target.value})} required />
            <button style={styles.btn} disabled={loading}>{loading ? "ログイン中..." : "ログイン"}</button>
          </form>
        )}
      </div>
    </div>
  );
}

const styles = {
  wrap: { minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center", background: "var(--bg-dark)", padding: 16 },
  card: { background: "var(--bg-mid)", borderRadius: 16, padding: 40, width: "100%", maxWidth: 420, boxShadow: "0 20px 60px rgba(0,0,0,0.5)" },
  logo: { fontSize: 48, textAlign: "center", marginBottom: 8 },
  title: { textAlign: "center", fontSize: 22, fontWeight: 700, color: "var(--accent)", marginBottom: 4 },
  sub: { textAlign: "center", color: "var(--text-muted)", fontSize: 13, marginBottom: 24 },
  tabs: { display: "flex", gap: 4, marginBottom: 20, background: "var(--bg-dark)", borderRadius: 8, padding: 4 },
  tab: { flex: 1, padding: "8px 4px", borderRadius: 6, background: "transparent", color: "var(--text-muted)", fontSize: 12, fontWeight: 600 },
  tabActive: { background: "var(--bg-light)", color: "var(--text)" },
  form: { display: "flex", flexDirection: "column", gap: 12 },
  row: { display: "flex", gap: 8 },
  input: { width: "100%", padding: "10px 14px", borderRadius: 8, border: "1px solid var(--border)", background: "var(--bg-dark)", color: "var(--text)", fontSize: 14 },
  btn: { padding: "12px", borderRadius: 8, background: "var(--accent)", color: "#000", fontWeight: 700, fontSize: 15 },
  error: { background: "rgba(248,113,113,0.15)", border: "1px solid var(--danger)", borderRadius: 8, padding: "10px 14px", color: "var(--danger)", fontSize: 13, marginBottom: 8 }
};
